<template>
    <!-- Marco permanente del modo gestion: nav arriba y footer institucional
         abajo se ven SIEMPRE (con y sin afiliado elegido). Se renderizan una
         sola vez, FUERA de la transicion; lo unico que se intercambia es el
         centro (iframe <-> busqueda). -->
    <div class="gestion-marco">
        <!-- Nav: tiene su propio toggle interno (expanded) que controla
             comprimir/expandir. No necesita transition externa. Se adapta solo
             (esconde "Viendo como" y "Volver") cuando todavia no hay afiliado. -->
        <NavGestion />

        <!-- Zona central intercambiable. Ocupa el alto que dejan libre el nav
             y el footer, que viven en el mismo flujo flex. -->
        <div class="gestion-centro">
            <v-fade-transition mode="out-in">
                <!-- Centro en modo iframe: el operador esta viendo un afiliado.
                     Gate reactivo (mostrarIframe), NO viendoAfiliado directo:
                     anti-flash en refresh (ver computed mostrarIframe). -->
                <div v-if="mostrarIframe" key="iframe" class="gestion-panel-iframe">
                    <!-- Loader sobre el iframe hasta que el portal del afiliado termina de cargar -->
                    <div v-show="iframeLoading" class="iframe-loader-wrapper">
                        <v-progress-circular indeterminate color="primary" size="64" width="4" />
                    </div>
                    <!-- :key fuerza remount del iframe cuando cambia de afiliado
                         (desde el FooterGestion). Sin esto, el iframe no detecta
                         el nuevo token persistido y se queda con la sesion vieja. -->
                    <iframe :key="nroafiActivo" :src="iframeUrl" class="gestion-iframe" @load="onIframeLoaded" />
                </div>

                <!-- Centro en modo busqueda: sin afiliado elegido. Es el unico
                     bloque que scrollea, asi el marco nunca se mueve. -->
                <div v-else key="busqueda" class="gestion-busqueda">
                    <v-container fluid class="py-10">
                        <div class="gestion-busqueda-contenido mx-auto">
                            <v-card class="rounded-lg mb-6 card-glass">
                                <v-card-text class="d-flex flex-column align-center py-6">
                                    <!--
                                        Logo solo en pantallas chicas: de sm para
                                        arriba el del nav ya cumple, y se veian los
                                        dos. Complementa al del nav, que usa
                                        d-none d-sm-flex.

                                        eager NO es opcional. Este v-img es el que
                                        apaga el overlay global (@load/@error ->
                                        ocultarOverlay) y es su unico disparador.
                                        Sin eager, v-img espera al
                                        IntersectionObserver (VImg.js: "if
                                        (hasIntersect && !isIntersecting &&
                                        !this.eager) return"), y con display:none
                                        de sm para arriba no intersecta nunca: no
                                        carga, no dispara @load y el overlay queda
                                        pegado en desktop. Con eager carga siempre,
                                        se muestre o no. No cuesta una descarga
                                        extra: es el mismo asset que el del nav.

                                        Si se mueve o se saca este v-img, hay que
                                        llevar ocultarOverlay a otro lado.
                                    -->
                                    <v-img src="@/assets/Logo-bt-07.png" max-width="220" contain eager
                                        class="mb-5 d-flex d-sm-none" @load="ocultarOverlay" @error="ocultarOverlay" />
                                    <!-- Sin saludo: el nav ya muestra al operador. -->
                                    <div class="text-body-1 black--text text--darken-1 text-center gestion-instruccion">
                                        Ingresá el número de afiliada/o y vas a ver su portal tal como lo ve esa
                                        persona.
                                    </div>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-title class="text-subtitle-1 font-weight-bold justify-center">
                                    <v-icon class="mr-2" color="primary">mdi-account-search-outline</v-icon>
                                    Ver como afiliada/o
                                </v-card-title>
                                <v-card-text class="pt-5">
                                    <v-form @submit.prevent="entrar">
                                        <ValidationObserver ref="obs" v-slot="{ invalid }">
                                            <div class="d-flex flex-row align-start">
                                                <ValidationProvider rules="required|numeric|max:6" v-slot="v"
                                                    class="flex-grow-1">
                                                    <v-text-field ref="campoNroAfi" v-model="nroafi" outlined :min="1"
                                                        :max="999999" label="Número de Afiliada/o" single-line
                                                        type="number" hide-spin-buttons class="mr-3"
                                                        :error-messages="v.errors[0]" @keydown="preventArrowKeys" />
                                                </ValidationProvider>
                                                <v-btn type="submit" elevation="0" class="px-6" height="56"
                                                    color="primary" :loading="loading" :disabled="invalid || loading">
                                                    <v-icon class="mr-2">mdi-eye-outline</v-icon>
                                                    Entrar
                                                </v-btn>
                                            </div>
                                        </ValidationObserver>
                                    </v-form>
                                </v-card-text>
                            </v-card>

                            <!-- <v-card class="rounded-lg card-glass">
                                <v-card-title class="text-subtitle-1 font-weight-bold">
                                    <v-icon class="mr-2" color="primary">mdi-account-search-outline</v-icon>
                                    Ver como afiliada/o
                                </v-card-title>
                                <v-card-text class="pt-5">
                                    <v-form @submit.prevent="entrar">
                                        <ValidationObserver ref="obs" v-slot="{ invalid }">
                                            <div class="d-flex flex-row align-start">
                                                <ValidationProvider rules="required|numeric|max:6" v-slot="v"
                                                    class="flex-grow-1">
                                                    <v-text-field ref="campoNroAfi" v-model="nroafi" outlined :min="1"
                                                        :max="999999" label="Número de Afiliada/o" single-line
                                                        type="number" hide-spin-buttons class="mr-3"
                                                        :error-messages="v.errors[0]" @keydown="preventArrowKeys" />
                                                </ValidationProvider>
                                                <v-btn type="submit" elevation="0" class="px-6" height="56"
                                                    color="primary" :loading="loading" :disabled="invalid || loading">
                                                    <v-icon class="mr-2">mdi-eye-outline</v-icon>
                                                    Entrar
                                                </v-btn>
                                            </div>
                                        </ValidationObserver>
                                    </v-form>
                                </v-card-text>
                            </v-card> -->
                        </div>
                    </v-container>
                </div>
            </v-fade-transition>
        </div>

        <!-- Chrome inferior permanente: buscador compacto (solo con afiliado
             elegido, animado) + footer institucional (siempre visible). Al vivir
             EN EL FLUJO del flex column no tapa nunca al centro y no necesita
             capas fixed superpuestas.
             Los dos buscadores no conviven: mostrarFooter solo se prende
             cuando mostrarIframe es true (ver watch). -->
        <div class="gestion-footer">
            <v-expand-transition>
                <FooterGestion v-if="mostrarFooter" />
            </v-expand-transition>
            <div class="footer-institucional">
                Dpto. de Sistemas - <span class="font-weight-bold primary--text">CAJA DE PSICÓLOGOS BS. AS.</span> ©
                2026
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex';
import NavGestion from '@/components/navigations/NavGestion.vue';
import FooterGestion from '@/components/navigations/FooterGestion.vue';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        NavGestion,
        FooterGestion,
    },
    created() {
        // Anti-flash: decidir ANTES del primer paint si este boot es un
        // refresh SIN ?code con viendoAfiliado stale (rehidratado desde
        // sessionStorage). En ese caso mostrarIframe arranca en false y el
        // dashboard del afiliado nunca llega a pintarse un frame.
        const tieneCode = !!this.$route.query.code
        this.refrescoSinCode = !tieneCode && this.viendoAfiliado
        // Overlay global activo hasta que cargue el logo de la vista de
        // busqueda. En modo iframe (mostrarIframe true) no aplica.
        if (!this.mostrarIframe) this.startLoading()
    },
    mounted() {
        const code = this.$route.query.code
        if (code) {
            // Limpiar el ?code de la barra de direcciones ANTES de canjearlo
            // para que no quede en el historial ni en logs del cliente.
            window.history.replaceState({}, document.title, window.location.pathname)
            this.canjearCodigo(code)
        } else if (this.viendoAfiliado) {
            // Recarga/refresh sin code estando viendo un afiliado: NO reanudar
            // esa vista (decision de producto). Volvemos a la pantalla de
            // busqueda del operador. cerrarVistaAfiliado limpia el token del
            // afiliado y el estado de vista, pero conserva la sesion de operador
            // (gestionSid) para poder seguir buscando sin reautenticarse.
            this.cerrarVistaAfiliado()
            // Anti-flash: consumir el flag one-shot tras el primer tick. Si
            // no se libera, un ENTER nuevo posterior (afiliado recien
            // elegido) quedaria con mostrarIframe pegado en false.
            this.$nextTick(() => {
                this.refrescoSinCode = false
            })
        }
        // Escuchamos al iframe: cuando el afiliado-impersonado cierra sesion
        // (boton "Cerrar sesion" adentro del portal), avisamos via postMessage
        // y aca cerramos el iframe para volver al form de busqueda del operador.
        window.addEventListener('message', this.handleMensajeIframe)
        // NOTA: NO hay logout en 'beforeunload'. Ese evento dispara tambien en
        // el REFRESH (no solo al cerrar), y no hay forma confiable de distinguir
        // refresh de cierre desde el cliente; cerraba la sesion de operador en
        // Redis en cada refresh, rompiendo la siguiente busqueda (loginAnillo ->
        // 401 -> login). Por decision de producto NO hay salida in-app: la
        // sesion de gestion termina al cerrar la pestana (el gestion_sid vive en
        // sessionStorage, que muere con la pestana) y del lado del servidor se
        // drena por el TTL de 4h en Redis (o por SESSION-1 al reingresar desde
        // SICA, que genera un sid nuevo y pisa al viejo).
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMensajeIframe)
        // Por las dudas, no dejar el overlay global colgado al salir.
        this.stopLoading()
    },
    data() {
        return {
            nroafi: '',
            // Loader sobre el iframe. Arranca en true; el @load del iframe lo
            // apaga cuando el portal del afiliado termino de cargar.
            iframeLoading: true,
            // Gate de la animacion de expand del FooterGestion. Se activa
            // con setTimeout despues del fade del wrapper iframe para que el
            // v-expand-transition detecte la entrada del hijo.
            mostrarFooter: false,
            // Anti-flash: flag one-shot decidido en created() ANTES del
            // primer paint. true SOLO cuando bootea un refresh SIN ?code con
            // viendoAfiliado stale. Se consume (vuelve a false) tras el
            // primer tick en mounted(), para no suprimir un ENTER nuevo.
            refrescoSinCode: false,
        }
    },
    computed: {
        // usuiden ya no se mapea aca: el nombre del operador lo muestra NavGestion.
        ...mapGetters('gestion', ['loading', 'viendoAfiliado', 'nroafiActivo']),
        // Gate reactivo del template (anti-flash). El refresh-viendo-afiliado
        // arranca en false (sin flash); un ENTER nuevo posterior SI renderiza
        // el iframe porque refrescoSinCode no se vuelve a activar.
        mostrarIframe() {
            return this.viendoAfiliado && !this.refrescoSinCode
        },
        iframeUrl() {
            // El iframe carga el dashboard como una instancia nueva de la
            // app que se autentica con el token persistido en sessionStorage.
            return this.$router.resolve({ path: '/dashboard' }).href
        },
    },
    watch: {
        // Sincronizado con mostrarIframe (no viendoAfiliado directo): si
        // quedara pegado al getter crudo, un refresh-sin-code con el
        // anti-flash activo dejaria mostrarFooter en un estado inconsistente.
        // immediate: true para que tambien se dispare al recargar la pagina
        // estando en modo gestion (viendoAfiliado se rehidrata desde
        // sessionStorage). Sin esto, mostrarFooter quedaba en false al mount
        // y el footer no aparecia hasta volver y entrar de nuevo.
        mostrarIframe: {
            immediate: true,
            handler(activo) {
                if (activo) {
                    // Resetear el loader del iframe para el nuevo afiliado.
                    this.iframeLoading = true
                    // Disparar la animacion de expand del FooterGestion DESPUES
                    // de que termine el fade-in del wrapper (~300ms del v-fade).
                    setTimeout(() => { this.mostrarFooter = true }, 350)
                } else {
                    // Al volver a busqueda, enrollar el Footer (collapse).
                    this.mostrarFooter = false
                }
            },
        },
        // Cambio en caliente de afiliado desde el FooterGestion. El iframe se
        // remonta por el :key="nroafiActivo", asi que reseteamos el loader
        // para que el spinner aparezca mientras carga el nuevo portal.
        nroafiActivo(nuevo, viejo) {
            if (nuevo && viejo && nuevo !== viejo) {
                this.iframeLoading = true
            }
        },
    },
    methods: {
        ...mapActions('gestion', ['canjearCodigo', 'entrarComoAfiliado', 'cerrarVistaAfiliado']),
        ...mapActions('notificaciones', ['startLoading', 'stopLoading', 'showSnack']),
        ocultarOverlay() {
            this.stopLoading()
            // Al quedar visible la vista de busqueda, dejamos el cursor listo
            // en el campo para que el operador tipee el numero directamente.
            this.enfocarCampo()
        },
        enfocarCampo() {
            this.$nextTick(() => {
                if (this.$refs.campoNroAfi) this.$refs.campoNroAfi.focus()
            })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) event.preventDefault();
        },
        onIframeLoaded() {
            this.iframeLoading = false
        },
        entrar() {
            this.$refs.obs.validate().then(result => {
                if (result) this.entrarComoAfiliado(this.nroafi)
            })
        },
        handleMensajeIframe(event) {
            // Validar origen para no aceptar mensajes de cualquier ventana.
            if (event.origin !== window.location.origin) return
            if (!event.data) return
            if (event.data.type === 'gestion-cerrar-sesion') {
                this.cerrarVistaAfiliado()
            } else if (event.data.type === 'gestion-afiliado-no-encontrado') {
                // La matricula no esta registrada (error 2): cerramos el iframe,
                // volvemos al form de busqueda y mostramos el mensaje del back.
                this.cerrarVistaAfiliado()
                this.showSnack({ message: event.data.msg, type: '400' })
            }
        },
    },
}
</script>

<style scoped>
/* Marco permanente del modo gestion: cubre todo el viewport (App.vue no
   renderiza su propia Nav en esta ruta) y ordena nav / centro / footer en una
   unica columna flex. Al estar TODO en el mismo flujo, el footer nunca tapa el
   centro y ya no hacen falta capas fixed superpuestas como antes.
   overflow:hidden corta cualquier scroll horizontal en mobile: el unico que
   scrollea (y solo en vertical) es el centro de busqueda. */
.gestion-marco {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f5f5f5;
}

/* Zona central intercambiable (iframe <-> busqueda). Toma el alto restante;
   min-height:0 para poder encogerse dentro del flex column y que el footer
   conserve su alto real. position:relative da contexto al loader del iframe. */
.gestion-centro {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
}

/* Fondo de la vista de busqueda (modo gestion sin afiliado seleccionado).
   Es el unico bloque scrolleable: si las cards no entran (mobile chico), el
   scroll vertical pasa aca adentro y el marco queda quieto. */
.gestion-busqueda {
    flex: 1 1 auto;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-image: url('~@/assets/fondo-06.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.gestion-busqueda-contenido {
    max-width: 720px;
}

/* Ancho de lectura de la instruccion de la card de bienvenida (antes iba
   como estilo inline, prohibido por convencion del proyecto). */
.gestion-instruccion {
    max-width: 480px;
}

/* Cards con leve transparencia + blur (efecto glassmorphism) para dejar
   ver el fondo difuminado por detras. */
.card-glass {
    background-color: rgba(255, 255, 255, 0.75) !important;
    /* Fuerza promocion a capa GPU desde el primer paint para que el
       backdrop-filter se aplique desde el principio, evitando el "flash"
       de card sin blur que aparece cuando el browser recompone. */
    transform: translateZ(0);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

/* Panel del centro cuando hay afiliado: contiene el iframe y su loader.
   Se estira dentro de .gestion-centro y no scrollea (el scroll lo maneja el
   portal del afiliado adentro del iframe). */
.gestion-panel-iframe {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    display: flex;
}

/* El iframe se presenta como un panel contenido (no una pagina suelta):
   margen que deja ver el fondo neutro del marco, borde sutil, esquinas
   redondeadas y sombra suave. */
.gestion-iframe {
    flex: 1 1 auto;
    width: auto;
    /* Margen parejo: el chrome inferior (FooterGestion + footer institucional)
       vive EN EL FLUJO del flex column del marco, asi que el iframe ocupa
       exactamente el espacio restante y el footer toma su alto real (sin hueco
       fijo debajo). min-width/min-height:0 para que pueda encogerse dentro del
       flex y no fuerce scroll horizontal en pantallas chicas. */
    min-width: 0;
    min-height: 0;
    margin: 6px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 1px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.10);
    background: white;
    overflow: hidden;
}

/* Loader centrado sobre el iframe mientras carga el portal del afiliado.
   El padre (.gestion-panel-iframe) es position: relative, lo que crea el
   contexto de positioning para este absolute. */
.iframe-loader-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
}

/* Chrome inferior permanente del marco: agrupa el FooterGestion (opcional,
   animado) y el footer institucional (siempre visible). Vive EN EL FLUJO del
   flex column (no fixed ni absolute), asi que toma su alto real, el centro
   (flex:1) ocupa el resto y el footer no tapa nunca contenido, ni cuando el
   FooterGestion aparece/desaparece. Full-width por el stretch por defecto. */
.gestion-footer {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
}

/* Footer institucional: barra angosta, siempre al pie, top-level (nunca
   dentro del iframe). Unica definicion: se renderiza una sola vez dentro del
   marco, valga el estado que valga (con o sin afiliado). */
.footer-institucional {
    background-color: #ffffff;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.7rem;
    text-align: center;
    padding: 6px 8px;
}
</style>
